import React, { Fragment, useCallback, useMemo, useState }  from "react";
import {compose} from "redux";
import {translate} from 'react-i18next';
import {connect} from "react-redux";
import EnhancedTree from "../../../components/enhanced-tree";
import Call from "../../../hocs/call";
import { readHierarchicalCodelistReferencedCodelists, 
  readHierarchicalCodelistDetailCodelistsForSelection, 
  addHierarchicalCodelistDetailIncludedCodelist, 
  deleteHierarchicalCodelistDetailIncludedCodelists, 
  //deleteHierarchicalCodelistDetailHCLItems,
  saveHierarchicalCodelistHierarchy,
  setHierarchicalCodelist} from "./actions";
import { getLocalizedStr } from "../../../middlewares/i18n/utils";
import { DataLanguageConsumer } from "../../../contexts/DataLanguage";
import { GUTTER_MD, MARGIN_MD, MODAL_WIDTH_LG, SPAN_HALF } from "../../../styles/constants";
import { Button, Col, Icon, Modal, Row, message } from "antd";
import { BUTTON_CHECK_ALL_CHILDS, BUTTON_COPY, BUTTON_CREATE, BUTTON_PARENTS_AND_CHILDREN, BUTTON_PASTE, BUTTON_PASTE_AS_BROTHER } from "../../../styles/buttons";
import _ from "lodash";
import { deleteItemsFromHCLHierarchies, findReferencedItems, getCodelistNodeId, getExistingNodesIds, getHclNodeHierarchy, getToPasteTree, isCodelistRootId, isHCLRootId, updateParentOfNodes } from "./utils";
import EnhancedModal from "../../../components/enhanced-modal";
import ArtefactList from "../../../components/artefact-list";
import { HIERARCHY_VALUE_BASED, getArtefactTripletFromUrn } from "../../../utils/sdmxJson";
import ReduxCodelistDetailModal from "../../../redux-components/redux-codelist-detail-modal";
import { HIERARCHICAL_CODELISTS_PREFIX } from "./reducer";
import { showCodelistDetail } from "../../../redux-components/redux-codelist-detail-modal/actions";
import { reuseAction } from "../../../utils/reduxReuse";
import HierarchyForm from "./HierarchyForm";
import { HIERARCHY_FORM_MODE_CREATE, HIERARCHY_FORM_MODE_EDIT, HIERARCHY_FORM_MODE_READ } from "./utils";
import { isHierarchicalCodelistDefinitionValid, isHierarchyArtefactValid } from "../../../utils/artefactValidators";
import { getNode, getNodes } from "../../../utils/tree";
import "./style.css"

const IconFontCNIcon = Icon.createFromIconfontCN({
  scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

const childrenKey="hierarchicalCodes";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  hierarchicalCodelist: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelist,
  includedCodelistsItemsTree: state.scenes.metaManager.hierarchicalCodelists.includedCodelistsItemsTree,
  codelists: state.scenes.metaManager.hierarchicalCodelists.codelists,
  codelistDetail: state.scenes.metaManager.hierarchicalCodelists.codelistDetail,
});

const mapDispatchToProps = dispatch => ({
  fetchReferencedCodelistsItemsTree: ({includedCodelists, lang}) => 
    dispatch(readHierarchicalCodelistReferencedCodelists(includedCodelists, childrenKey, lang)),
  fetchCodelistsForSelection: () => dispatch(readHierarchicalCodelistDetailCodelistsForSelection()),
  onAddCodelistToHierarchicalCodelist: (triplet) => 
    dispatch(addHierarchicalCodelistDetailIncludedCodelist(triplet, childrenKey)),
  deleteIncludedCodelists: (codelists) => 
    dispatch(deleteHierarchicalCodelistDetailIncludedCodelists(codelists)),
  onCodelistDetailShow: (codelistTriplet) =>
    dispatch(reuseAction(showCodelistDetail(codelistTriplet), HIERARCHICAL_CODELISTS_PREFIX)),
  saveHierarchy: (hierarchy, lang, pos) => 
    dispatch(saveHierarchicalCodelistHierarchy(hierarchy, lang, pos)),

  onHierarchicalCodelistSet : (hierarchicalCodelist) => dispatch(setHierarchicalCodelist(hierarchicalCodelist)),
});



const HierarchicalCodelistDetailItems = ({
    t,
    disabled,
    autoSave,
    onHierarchicalCodelistSave,
    appLanguage,
    dataLanguages,
    hierarchicalCodelist,
    includedCodelistsItemsTree,  
    codelists,
    codelistDetail,
    fetchReferencedCodelistsItemsTree,
    fetchCodelistsForSelection,
    onAddCodelistToHierarchicalCodelist,
    deleteIncludedCodelists,
    // deleteHCLItems,
    onCodelistDetailShow,
    saveHierarchy,
    onHierarchicalCodelistSet
}) => {

  const [isCodelistsForSelectionVisible, setIsCodelistsForSelectionVisible] = useState(false);
  const [isHierarchyFormVisible, setIsHierarchyFormVisible] = useState(false);
  const [hierarchy, setHierarchy] = useState(null);
  const [hierarchyMode , setHierarchyMode] = useState(HIERARCHY_FORM_MODE_CREATE);

  const [codelistsSelectedItems, setCodelistsSelectedItems] = useState([]);
  const [isCodelistSelected, setCodelistSelected] = useState(false);
  const [hclSelectedItems, setHclSelectedItems] = useState([]);
  const [isHierarchySelected, setHierarchySelected] = useState(false);

  const [toPasteKeys, setToPasteKeys] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState(appLanguage);

  /** Codelists tree */

  const onCodelistsTreeSelect = useCallback( (selectedArr) => {

    if (disabled) {
      return;
    }

    if (selectedArr.length === 0) {
      setCodelistsSelectedItems([]);
      setCodelistSelected(false);
    }
    else {
      let anotherTypeNodes = [];
      const hasSelectedHierarchy = isCodelistRootId(selectedArr[0]);
      if (hasSelectedHierarchy) {
        anotherTypeNodes = selectedArr.filter(h => !isCodelistRootId(h));        
      } else {
        anotherTypeNodes = selectedArr.filter(h => isCodelistRootId(h));        
      }

      if (anotherTypeNodes.length > 0) {
        Modal.confirm({
          title: t('components.hierarchicalCodelistDetailItems.selectedItems.notSameType.title'),
          cancelText: t('commons.buttons.cancel.title'),
          onOk() {
            setCodelistsSelectedItems(anotherTypeNodes);
            setCodelistSelected(hasSelectedHierarchy);            
          },        
        })
      } else {
        setCodelistsSelectedItems(selectedArr);
        setCodelistSelected(hasSelectedHierarchy); 
      }      
    }

  }, []);

  const onSelectUnselectCodelistNodeChildren = useCallback((node, cancelSelection, codelistsSelectedItems) => {
    const selectedItems = cancelSelection ? [] : codelistsSelectedItems || [];
    const childIds = node[childrenKey].map(({uniqueId}) => uniqueId);
    
    const mergedIds = _.uniq(childIds.concat(selectedItems));

    let newSelectedItems =
      mergedIds.length > selectedItems.length
        ? mergedIds
        : selectedItems.filter(id => !childIds.includes(id));
    
      setCodelistsSelectedItems(newSelectedItems);
      setCodelistSelected(false);
  }, [childrenKey]);

  const selectUnselectCodelistNodeChildren = useCallback((node, isCodelistSelected, codelistsSelectedItems) => 
  {
    if (isCodelistSelected) {
      Modal.confirm({
        title: t('components.hierarchicalCodelistDetailItems.selectedItems.notSameType.title'),
        onOk() {
          onSelectUnselectCodelistNodeChildren(node, true, codelistsSelectedItems);
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    } else {
      onSelectUnselectCodelistNodeChildren(node, false, codelistsSelectedItems);
    }
  }, [onSelectUnselectCodelistNodeChildren]);


  const selectUnselectCodelistItems = useCallback( (node, isCodelistSelected, codelistsSelectedItems) => {

    if (isCodelistSelected) {
      Modal.confirm({
        title: t('components.hierarchicalCodelistDetailItems.selectedItems.notSameType.title'),
        onOk() {
          onSelectUnselectCodelistItems(node, true, codelistsSelectedItems);
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    } else {
      onSelectUnselectCodelistItems(node, false, codelistsSelectedItems);
    }

  }, []);

  const onSelectUnselectCodelistItems = useCallback((node, cancelSelection, codelistsSelectedItems) => {
    const selectedItems = cancelSelection ? [] :codelistsSelectedItems || [];
    const childIds = getNodes(node[childrenKey], childrenKey, () => true).map(({uniqueId}) => uniqueId);    
    const mergedIds = _.uniq(childIds.concat(selectedItems));

    let newSelectedItems =
      mergedIds.length > selectedItems.length
        ? mergedIds
        : selectedItems.filter(id => !childIds.includes(id));
    setCodelistsSelectedItems(newSelectedItems);
    setCodelistSelected(false);
  }, [childrenKey]);

  const clearCodelistTreeSelection = useCallback(() => 
  {
    setCodelistsSelectedItems([]);
    setCodelistSelected(false);
  }, []);

  const onSelectCodelist = useCallback((codelist, includedCodelistsItemsTree) => {
    let rootId = getCodelistNodeId(codelist.agencyID,codelist.id,codelist.version);
    const includedCodelist = includedCodelistsItemsTree.find(c => c.isRoot && c.uniqueId === rootId)
    if (includedCodelist) {
      message.warning(t("components.hierarchicalCodelistDetailItems.warning.codelistSelect.message", {id: rootId}))
    }
    else {
      onAddCodelistToHierarchicalCodelist(getArtefactTripletFromUrn(codelist.urn));
    }
    
    setIsCodelistsForSelectionVisible(false);
  }, []);

  const onDeleteCodelists = useCallback( (includedCodelistsItemsTree, codelistsSelectedItems, hierarchicalCodelist) => 
  {
    let includedCodelists = includedCodelistsItemsTree.filter(c => c.isRoot && codelistsSelectedItems.includes(c.uniqueId));
    let toDeleteCodelists = [];
    let errorContent = [];
    (includedCodelists || []).forEach( cl => 
      {
        let clReferencedItems = {};
        findReferencedItems(hierarchicalCodelist.hierarchies, cl.codelistAliasRef, clReferencedItems);
        if (Object.keys(clReferencedItems).length > 0) 
        {
          errorContent.push(<hr key={`hr_err__key__${cl.id}`}/>);
          let err = <div key={`div_err__key__${cl.id}`} ><p key={`p_cl_err__key__${cl.id}`}><b>Codelist: {cl.id}</b></p>
                      <ul key={`ul_err__key__${cl.id}`}>
                        {
                          Object.keys(clReferencedItems).map((k) => 
                            <li key={`li_err__${cl.id}__${k}__key`}>
                              {clReferencedItems[k].join(", ")}
                            </li>
                            )
                        }
                      </ul>
                    </div>; // <p id={`p_items_err__${cl.id}`}><b>Items: </b>{clReferencedItems.join(", ")}</p>
          errorContent.push(err);
        }
        else {
          toDeleteCodelists.push(cl.uniqueId);
        }
      });

      if (errorContent.length > 0)
      {                 
        
        Modal.error({
          title: t('components.hierarchicalCodelistDetailItems.error.codelistDelete.title'),
          content: <div key="hcl_err_div_key">{errorContent}</div>
        })
      }
      
      if (toDeleteCodelists.length > 0) 
      {
        setCodelistsSelectedItems([]);
        setCodelistSelected(false);
        deleteIncludedCodelists(toDeleteCodelists);
      }

  }, []);

  const onCopy = useCallback((key, codelistsSelectedItems) => {
    const selectedItems = _.clone(codelistsSelectedItems || []);
    const toCopyKeys = key ? _.union(selectedItems, [key]) : selectedItems;
    setToPasteKeys(toCopyKeys);
    message.success(t("components.hierarchicalCodelistDetailItems.success.copy.message"));
  }, []);

  const codelistsTreeNodeActions =  useMemo(() => {
    return (
      [
        node =>
          node[childrenKey] && node[childrenKey].length > 0 && !node.isRoot && !disabled
            ? ({
              ...BUTTON_CHECK_ALL_CHILDS,
              title: t("components.hierarchicalCodelistDetailItems.selectUnselectAllChildren.title"),
              onClick: () => {selectUnselectCodelistNodeChildren(node, isCodelistSelected, codelistsSelectedItems)}
            })
            : null,
        node =>
          node.isRoot && !disabled
          ? ({
            ...BUTTON_PARENTS_AND_CHILDREN,
            title: t("components.hierarchicalCodelistDetailItems.selectUnselectAllItems.title"),
            onClick: () => {selectUnselectCodelistItems(node, isCodelistSelected, codelistsSelectedItems)}
          })
          : null
      ]
    );
  }, [childrenKey,disabled, isCodelistSelected, codelistsSelectedItems, selectUnselectCodelistNodeChildren, selectUnselectCodelistItems]);

  const codelistsTreeRightActions = useMemo(() => {
    return (
      <Row type="flex" justify="end" gutter={GUTTER_MD}>
        {codelistsSelectedItems.length > 0 && (
        <Col>
          <Button 
            type="primary"                      
            onClick={() => clearCodelistTreeSelection()}
          >
            {t("components.hierarchicalCodelistDetailItems.trees.unselect.title")}
          </Button>                     
        </Col>)}
        <Col>
          <Button
            onClick={() => 
              Modal.confirm({
                title: t('components.hierarchicalCodelistDetailItems.selectedItems.delete.title'),
                onOk() {onDeleteCodelists(includedCodelistsItemsTree, codelistsSelectedItems, hierarchicalCodelist)},
                cancelText: t('commons.buttons.cancel.title')
              })}
            icon="delete"
            title={t("components.hierarchicalCodelistDetailItems.codelists.delete.title")}
            disabled={!isCodelistSelected || disabled}
          />
        </Col>
        <Col>
          <Button
            {...BUTTON_CREATE}                           
            onClick={() => setIsCodelistsForSelectionVisible(true)}
            title={t("components.hierarchicalCodelistDetailItems.codelists.add.title")}
            disabled={disabled}
          />
        </Col>                          
        <Col>
          <Button
            {...BUTTON_COPY}                           
            onClick={() => onCopy(null, codelistsSelectedItems)}
            title={t("components.hierarchicalCodelistDetailItems.codelists.copy.title")}
            disabled={isCodelistSelected || (codelistsSelectedItems || []).length === 0}
          />                         
        </Col>
      </Row>
    )
  }, [hierarchicalCodelist,codelistsSelectedItems,includedCodelistsItemsTree, isCodelistSelected,
    clearCodelistTreeSelection, onDeleteCodelists, disabled]);

  const codelistsTreeRightClickActions = useMemo(() => {
    const actions = [
      node => (!node.isRoot && !disabled)
      ? ({
        ...BUTTON_COPY,
        title: t("components.hierarchicalCodelistDetailItems.codelists.copy.title"),
        onClick: () => {onCopy(node.uniqueId, codelistsSelectedItems)},
        disabled:isCodelistSelected || (codelistsSelectedItems || []).length === 0
      })
      : null,
    ];
    return actions;
  }, [isCodelistSelected,codelistsSelectedItems,disabled]);

  /** Hierarchies tree */

  const onHierarchiesTreeSelect = useCallback((selectedArr) => {

    if (disabled) {
      return;
    }

    if (selectedArr.length === 0) {
      setHclSelectedItems([]);
      setHierarchySelected(false);
    }
    else {
      let anotherTypeNodes = [];
      const hasSelectedHierarchy = isHCLRootId(selectedArr[0]);
      if (hasSelectedHierarchy) {
        anotherTypeNodes = selectedArr.filter(h => !isHCLRootId(h));        
      } else {
        anotherTypeNodes = selectedArr.filter(h => isHCLRootId(h));        
      }

      if (anotherTypeNodes.length > 0) {
        Modal.confirm({
          title: t('components.hierarchicalCodelistDetailItems.selectedItems.notSameType.title'),
          cancelText: t('commons.buttons.cancel.title'),
          onOk() {
            setHclSelectedItems(anotherTypeNodes);
            setHierarchySelected(hasSelectedHierarchy);            
          },        
        })
      } else {
        setHclSelectedItems(selectedArr);
        setHierarchySelected(hasSelectedHierarchy); 
      }      
    }
  }, []);

  const selectUnselectHierarchyNodeChildren = useCallback((node, isHierarchySelected, hclSelectedItems) => 
  {
    if (isHierarchySelected) {
      Modal.confirm({
        title: t('components.hierarchicalCodelistDetailItems.selectedItems.notSameType.title'),
        onOk() {
          onSelectUnselectHierarchyNodeChildren(node, true, hclSelectedItems);
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    } else {
      onSelectUnselectHierarchyNodeChildren(node, false, hclSelectedItems);
    }
  }, []);

  const onSelectUnselectHierarchyNodeChildren = useCallback((node , cancelSelection, hclSelectedItems) => {

    const selectedItems = cancelSelection ? [] : hclSelectedItems || [];
    const childIds = node[childrenKey].map(({uniqueId}) => uniqueId);
    
    const mergedIds = _.uniq(childIds.concat(selectedItems));

    let newSelectedItems =
      mergedIds.length > selectedItems.length
        ? mergedIds
        : selectedItems.filter(id => !childIds.includes(id));
    
      setHclSelectedItems(newSelectedItems);
      setHierarchySelected(false);
  }, [childrenKey]);

  const onHierarchyCreate = useCallback(() => 
  {
    const emptyHierarchy = {
      id: null,
      name: null,
      names: null,
      description: null,
      descriptions: null,
      type: HIERARCHY_VALUE_BASED,
      annotations: [],
      leveled: false,
      uniqueId: null,
      codeID: null,
      isRoot: true
    };
    setHierarchy(emptyHierarchy);
    setHierarchyMode(HIERARCHY_FORM_MODE_CREATE);
    setIsHierarchyFormVisible(true);
  }, []);

  const onHierarchyShow = useCallback((hierarchy) => 
  {
      setHierarchy(hierarchy);
      setHierarchyMode(disabled ? HIERARCHY_FORM_MODE_READ : HIERARCHY_FORM_MODE_EDIT)
      setIsHierarchyFormVisible(true);
    
  }, []);

  const onHierarchyFormClose = useCallback(() => 
  {
    setIsHierarchyFormVisible(false);
  }, []);

  const onHierarchySave = useCallback((hierarchy, lang, isHierarchySelected, hclSelectedItems) => 
  {
    if (hierarchyMode === HIERARCHY_FORM_MODE_CREATE) {
      let existingHierarchy = (hierarchicalCodelist.hierarchies || []).find(h => h.id === hierarchy.id);
      if (existingHierarchy) {
        Modal.error({
          title: t("components.hierarchicalCodelistDetailItems.error.newHierarchy.title", {id: hierarchy.id} ),
        });
        return;
      }
    }    
    let pos = -1;
    if (isHierarchySelected && (hclSelectedItems || []).length === 1 ) {
      let index = (hierarchicalCodelist.hierarchies || []).findIndex(h => h.id === hclSelectedItems[0]);
      pos = index + 1;
    }
    saveHierarchy(hierarchy, lang, pos);
    onHierarchyFormClose();
  }, [hierarchicalCodelist, hierarchyMode]);

  const hierarchicalCodelistAutoSave = useCallback((hcl) => {
    if (autoSave && onHierarchicalCodelistSave && isHierarchicalCodelistDefinitionValid(hcl)) {
      onHierarchicalCodelistSave(hcl);
    }
  }, [onHierarchicalCodelistSave, autoSave]);

  const deleteHclNodes = useCallback((nodesToDelete) => {
    const hcl = _.cloneDeep(hierarchicalCodelist);
    deleteItemsFromHCLHierarchies(hcl, nodesToDelete );
    onHierarchicalCodelistSet(hcl);
    hierarchicalCodelistAutoSave(hcl);
  }, [hierarchicalCodelist, onHierarchicalCodelistSet, hierarchicalCodelistAutoSave])

  const onDeleteHCLItems = useCallback( (hclSelectedItems) => {

    let nodesToDelete = hclSelectedItems;
    let content;

    const selectedNodes = getNodes(hierarchicalCodelist.hierarchies, childrenKey, (node => hclSelectedItems.includes(node.uniqueId)));    
    const hasRootNode = selectedNodes.some(node => node.isRoot);

    if (!hasRootNode) 
    {
      const selectedNodesCount = selectedNodes.length;
      const nodesWithoutChildren = selectedNodes.filter(node => (node[childrenKey] || []).length === 0);
      const nodesWithoutChildrenCount = nodesWithoutChildren.length;
      if (nodesWithoutChildrenCount === 0) {
        Modal.error({
          title: t("components.hierarchicalCodelistDetailItems.error.deleteHclItem.title"),
        });
        return;
      }
      else if (selectedNodesCount !== nodesWithoutChildrenCount) {
        nodesToDelete = nodesWithoutChildren.map(({uniqueId}) => uniqueId);
        content = t('components.hierarchicalCodelistDetailItems.selectedItems.delete.content');
      }     
    }

    Modal.confirm({
      title: t('components.hierarchicalCodelistDetailItems.selectedItems.delete.title'),
      content: content,
      onOk() {
        setHclSelectedItems([]);
        setHierarchySelected(false);
        deleteHclNodes(nodesToDelete);
      },
      cancelText: t('commons.buttons.cancel.title')
    })
  }, [hierarchicalCodelist, childrenKey, deleteHclNodes]);

  const clearHclSelection = useCallback(() => 
  {
    setHclSelectedItems([]);
    setHierarchySelected(false);
  }, []);

  const resetCopySelection = useCallback(() => {
    setHclSelectedItems([]);
    // setHierarchySelected(false);
    // setToPasteKeys([]);
  }, []);

  const onDrop = useCallback((ev) => {

    let hcl = _.cloneDeep(hierarchicalCodelist);    
    let tree = hcl.hierarchies || [];

    const evDragNode = ev.dragNode.props["data-node"]; 
    const dragNodeId = evDragNode.uniqueId;
    const dragIds = _.union(hclSelectedItems || [], [dragNodeId]);
    
    let eDropNode = ev.node.props["data-node"];
    

    if (dragIds.includes(eDropNode.uniqueId)) {
      message.warning(t("components.hierarchicalCodelistDetailItems.warning.dragNodes.containsDropNode.message"));
      resetCopySelection();
      return;
    }    

    const dragNodes = getNodes(tree, childrenKey, (node => dragIds.includes(node.uniqueId)));
    
    let allNodesSameLevel = dragNodes.every(node => node.parent === evDragNode.parent);   
    if (!allNodesSameLevel) {
      message.warning(t("components.hierarchicalCodelistDetailItems.warning.dragNodes.notSameLevel.message"));
      resetCopySelection();
      return;
    }
  
    const evPos = ev.node.props.pos.split('-');
    const dropPos = ev.dropPosition - Number(evPos[evPos.length - 1]);
    const onTop = dropPos === -1; // drop on top node gap
    const onNode = !ev.dropToGap; // drop on node
 
    const evDropNode = getNode(tree,childrenKey,(node => node.uniqueId === eDropNode.uniqueId));

    if (evDragNode.isRoot ) {

      // all dragNodes are hierachies

      if (!evDropNode.isRoot) {
        message.warning(t("components.hierarchicalCodelistDetailItems.warning.dragNodes.hierarchyToNotHierarchy.message"));
        resetCopySelection();
        return;
      }

      
      // change order of hierarchies      
       
      let hierarchies = hcl.hierarchies.filter(h => !dragIds.includes(h.uniqueId));
      let index = hierarchies.findIndex(h => h.uniqueId === evDropNode.uniqueId);
      let pos = onTop 
        ? index === 0 ? 0 : index - 1
        : index + 1;

        dragNodes.forEach(node => {
          hierarchies.splice(pos++, 0, node);
        })
        
        hcl.hierarchies = hierarchies;        
      
    } else {

      // riorganizzazione (spostamento) all'interno di una gerarchia e allo stesso livello gerarchico   
      
      const dragHierarchyId = getHclNodeHierarchy(evDragNode);
      const dropHierarchyId = getHclNodeHierarchy(evDropNode);

      if (dragHierarchyId !== dropHierarchyId) {
        message.warning(t('components.hierarchicalCodelistDetailItems.warning.drop.notSameHierarchy.title'));
        resetCopySelection();      
        return;
      }

      let pos = -1;
      let dropNode = null;
      if (!evDropNode.isRoot && !onNode) {
        // drop on parent as brother
        dropNode = getNode(tree, childrenKey, (n => n.uniqueId === evDropNode.parent));
        if ((dropNode[childrenKey] || []).length === 0) {
          dropNode[childrenKey] = [];
        }       
        pos = dropNode[childrenKey].findIndex(n => n.uniqueId === evDropNode.uniqueId);
      }
    

      const finalDropNode =  dropNode !== null ? dropNode : evDropNode;
      if ((finalDropNode[childrenKey] || []).length === 0) {
        finalDropNode[childrenKey] = [];
      }

      // update parent and uniqueid of dragNodes
      const newDragNodes = updateParentOfNodes(dragNodes, finalDropNode.uniqueId, childrenKey);

      // remove from old Position
      const parent = getNode(tree, childrenKey, (n => n.uniqueId === dragNodes[0].parent ));
      if (parent) {
        dragNodes.forEach(node => {
          let index = parent[childrenKey].findIndex(n => n.uniqueId === node.uniqueId);
          if (index > -1) { 
            parent[childrenKey].splice(index, 1);
          }
        })        
      }

      // drop on new position
      if (onNode) {
        newDragNodes.forEach(node => {
          finalDropNode[childrenKey].push(node);
        });
        
      } else {
        let newPos = onTop ? pos -1 : pos + 1;
        if (newPos === -1) {
          newPos = 0;
        }
        newDragNodes.forEach(node => {
          finalDropNode[childrenKey].splice(newPos++, 0, node);
        })        
      }
    }

    message.success(t("components.hierarchicalCodelistDetailItems.success.drop.message"));
    resetCopySelection();
    onHierarchicalCodelistSet(hcl);
    hierarchicalCodelistAutoSave(hcl);
  }, [childrenKey, hierarchicalCodelist,hclSelectedItems, hierarchicalCodelistAutoSave]);

  const onPaste = useCallback( (nodeId,asChild, toPasteKeys) => 
  {
    if ((toPasteKeys.length || []) === 0) {
      return;
    }

    let hcl = _.cloneDeep(hierarchicalCodelist);
    let tree = hcl.hierarchies || [];

    let orNode = getNode(tree, childrenKey, (node => node.uniqueId === nodeId));
    if (!orNode[childrenKey]) {
      orNode[childrenKey] = [];
    }

    let destNode = orNode;
    let pos = 0;
    if (!asChild) {
      const parent = orNode.parent;
      destNode = getNode(tree, childrenKey, (node => node.uniqueId === parent));
      if (!destNode[childrenKey]) {
        destNode[childrenKey] = [];
      }
      let index = destNode[childrenKey].findIndex(node => node.uniqueId === orNode.uniqueId)
      if (index === -1) {
        pos = 0;
      } else {
        pos = index + 1;
      };
    }

    let toPasteNodes = getNodes(includedCodelistsItemsTree,childrenKey,(node => toPasteKeys.includes(node.uniqueId)));
    const toPasteTree = getToPasteTree(toPasteNodes,"uniqueId", childrenKey, destNode);
    let existingNodesIds = getExistingNodesIds(destNode[childrenKey] || [], toPasteTree, "uniqueId");
    let existingNodes = toPasteNodes.filter(node => existingNodesIds.includes(node.id)).map(node => node.uniqueId);
      
    if (existingNodes.length > 0) {
      Modal.error({
        title: t("components.hierarchicalCodelistDetailItems.error.pasteExistingKeys.title"),
        content: <div>
                    {existingNodes.map((n,index) => <p key={index}>{n}</p>)}
                 </div>
      });
      return;
    }

   // Paste on position

   if (asChild) {
      // paste to end of node
      toPasteTree.forEach( node => destNode[childrenKey].push(node) );
    } else {
      if (pos < 0) {
        pos = 0;
      }
      toPasteTree.forEach( node => destNode[childrenKey].splice(pos++, 0, node) );
      
    }
    message.success(t("components.hierarchicalCodelistDetailItems.success.paste.message"));
    setToPasteKeys([]);
    onHierarchicalCodelistSet(hcl);
    hierarchicalCodelistAutoSave(hcl);
  }, [hierarchicalCodelist, childrenKey, hierarchicalCodelistAutoSave]);

  const hclTreeNodeActions = useMemo(() => {
    const nodeActions = [
        node =>
          node.isRoot
            ? {                       
                icon:"file-text",
                className:"button-color-blue",                        
                title: t("components.hierarchicalCodelistDetailItems.hcl.edit.title"),
                onClick: () => {onHierarchyShow(node)}                          
            }
            : null,
          node =>
            node[childrenKey] && node[childrenKey].length > 0 && !node.isRoot && !disabled
              ? ({
                ...BUTTON_CHECK_ALL_CHILDS,
                title: t("components.hierarchicalCodelistDetailItems.selectUnselectAllChildren.title"),
                onClick: () => {selectUnselectHierarchyNodeChildren(node, isHierarchySelected, hclSelectedItems)}
              })
              : null,
      ];
      return nodeActions;
    }, [childrenKey,isHierarchySelected,hclSelectedItems]);
  
  const hclTreeRightActions = useMemo( () => {
    return (
      <Row type="flex" justify="end" gutter={GUTTER_MD}>
        {hclSelectedItems.length > 0 && (
          <Col>
            <Button 
              type="primary"                      
              onClick={() => clearHclSelection()}
            >
              {t("components.hierarchicalCodelistDetailItems.trees.unselect.title")}
            </Button>                     
          </Col>)}
        <Col>
          <Button
            onClick={() => onDeleteHCLItems(hclSelectedItems)}
            icon="delete"
            title={t("components.hierarchicalCodelistDetailItems.hierarchies.delete.title")}
            disabled={hclSelectedItems.length === 0}
          />
        </Col>
        <Col>
          <Button
            {...BUTTON_CREATE}
            onClick={() => onHierarchyCreate()}
            title={t("components.hierarchicalCodelistDetailItems.hcl.new.title")}
            disabled={disabled}
          />
        </Col>                           
        <Col>
          <Button  
            {...BUTTON_PASTE}      
            title={t("components.hierarchicalCodelistDetailItems.hcl.pasteAsChild.title")}            
            onClick={() => onPaste(hclSelectedItems[0],true,toPasteKeys)}
            disabled={toPasteKeys.length === 0 || (hclSelectedItems || []).length !== 1}                            
          />
        </Col> 
        <Col>
          <Button  
            {...BUTTON_PASTE_AS_BROTHER}      
            title={t("components.hierarchicalCodelistDetailItems.hcl.pasteAsBrother.title")}            
            onClick={() => onPaste(hclSelectedItems[0],false, toPasteKeys)}
            disabled={ (toPasteKeys  || []).length === 0 || (hclSelectedItems || []).length !== 1 || isHierarchySelected }                          
          />
        </Col>                    
      </Row>
    )}, [hclSelectedItems, toPasteKeys, isHierarchySelected, onPaste]);

  const hclTreeRightClickActions = useMemo(() => {
    const actions = [
      node => (!disabled)
      ? ({
        ...BUTTON_PASTE,
        title: t("components.hierarchicalCodelistDetailItems.hcl.pasteAsChild.title"),
        onClick: () => {onPaste(node.uniqueId,true, toPasteKeys)},
        disabled:(toPasteKeys || []).length === 0 || (hclSelectedItems || []).length !== 1
      })
      : null,
      node => (!node.isRoot && !disabled)
      ? ({
        ...BUTTON_PASTE_AS_BROTHER,
        title: t("components.hierarchicalCodelistDetailItems.hcl.pasteAsBrother.title"),
        onClick: () => {onPaste(node.uniqueId,false, toPasteKeys)},
        disabled:(toPasteKeys  || []).length === 0 || (hclSelectedItems || []).length !== 1 || isHierarchySelected
      })
      : null,
    ];
    return actions;
  }, [toPasteKeys, childrenKey,isHierarchySelected,hclSelectedItems, onPaste])

  

  /** Common */

  const getNodeKey = useCallback(({uniqueId}) => uniqueId, []);

  const getFilter = useCallback((searchText) => ({id, name}) => {
      const search = searchText.toLowerCase();
      return (id && id.toLowerCase()
          .indexOf(search) >= 0) || getLocalizedStr(name, currentLanguage, dataLanguages)
          .toLowerCase()
          .indexOf(search) >= 0;
    }, [currentLanguage, dataLanguages]);

  const getIcon = useCallback((node) => {
      return node.isRoot
        ? <IconFontCNIcon
            type="database"
          />
        : null; 
    }, []);
  
  const getNodeTextColor = useCallback(({isRoot}) => isRoot ? "red" : null, []);
  const getNodeClassName = useCallback(({isRoot}) => isRoot ? "tree_node_bold" : null, []);

  return (
    <Fragment>
    
      <DataLanguageConsumer>
        {dataLanguage => {
          const lang = dataLanguage || appLanguage;
          setCurrentLanguage(lang);
          return (
            <Call
              cb={fetchReferencedCodelistsItemsTree} 
              cbParam={{includedCodelists:hierarchicalCodelist !== null ? hierarchicalCodelist.includedCodelists: null, lang}}
              disabled={hierarchicalCodelist === null}
            >
              <Row 
                gutter={GUTTER_MD} 
                className="hcl__items__tree"
                style={{marginBottom: MARGIN_MD}}
                >
                <Col span={SPAN_HALF}>
                  {includedCodelistsItemsTree ? (
                      <EnhancedTree             
                        tree={includedCodelistsItemsTree}
                        getNodeKey={getNodeKey}
                        childrenKey={childrenKey}
                        getFilter={getFilter}
                        idKey="uniqueId"
                        nameKey="name"
                        catIdKey="id"
                        catNameKey="name"
                        icon="file-text"                  
                        isEmptyCategoryIconLikeLeafIcon
                        getIcon={getIcon}
                        getNodeClassName={getNodeClassName}
                        defaultCollapsed
                        multiple
                        externalControlledSelectedKeys
                        onSelect={onCodelistsTreeSelect}
                        selectedKeys={codelistsSelectedItems}
                        nodeActions={codelistsTreeNodeActions}
                        rightActions={codelistsTreeRightActions}
                        rightClickActions={codelistsTreeRightClickActions}
                      />
                    )
                  : (<span></span>)
                  }
                </Col>
              
                <Col span={SPAN_HALF}>
                  {hierarchicalCodelist && includedCodelistsItemsTree ? (
                    <EnhancedTree          
                      tree={hierarchicalCodelist.hierarchies || []}
                      getNodeKey={getNodeKey}
                      childrenKey={childrenKey}                  
                      getFilter={getFilter}
                      idKey="uniqueId"
                      nameKey="name"
                      catIdKey="id"
                      catNameKey="name"
                      icon="file-text"                  
                      isEmptyCategoryIconLikeLeafIcon
                      getIcon={getIcon}
                      defaultCollapsed
                      multiple
                      externalControlledSelectedKeys
                      onSelect={onHierarchiesTreeSelect}                  
                      selectedKeys={hclSelectedItems} 
                      getNodeTextColor={getNodeTextColor}
                      getNodeClassName={getNodeClassName}
                      nodeActions={hclTreeNodeActions} 
                      rightActions={hclTreeRightActions} 
                      rightClickActions={hclTreeRightClickActions}
                      draggable={!disabled}
                      onDrop={onDrop}              
                    />
                  )
                : (<span></span>)
                }
                </Col>
              </Row> 			     

            </Call>
          )
        }}
      </DataLanguageConsumer>

      <EnhancedModal
        visible={isCodelistsForSelectionVisible }
        width={MODAL_WIDTH_LG}
        title={t('components.hierarchicalCodelistDetailItems.codelistsSelector.title')}
        onCancel={() => setIsCodelistsForSelectionVisible(false)}
        footer={<Button onClick={() => setIsCodelistsForSelectionVisible(false)}>{t('commons.buttons.close.title')}</Button>}
        withDataLanguageSelector
      >  
        <Call 
          cb={fetchCodelistsForSelection} 
          disabled={!isCodelistsForSelectionVisible || codelists !== null}
        >          
          <ArtefactList
            artefacts={codelists}
            onRowClick={(c) => onSelectCodelist(c, includedCodelistsItemsTree)}
            getIsDisabledRow={({isFinal}) => !isFinal}
            onDetailShow={onCodelistDetailShow}
          />
        </Call>
      </EnhancedModal>

      <ReduxCodelistDetailModal
        instancePrefix={HIERARCHICAL_CODELISTS_PREFIX}
        instanceState={codelistDetail}
      />

      <EnhancedModal
        visible={isHierarchyFormVisible}
        width={MODAL_WIDTH_LG}
        title={hierarchyMode === HIERARCHY_FORM_MODE_CREATE
          ? t('components.hierarchicalCodelistDetailItems.hierarchyForm.create.title')
          : hierarchyMode === HIERARCHY_FORM_MODE_READ
          ? t('components.hierarchicalCodelistDetailItems.hierarchyForm.view.title')
          : t('components.hierarchicalCodelistDetailItems.hierarchyForm.edit.title')}
        onCancel={() => setIsHierarchyFormVisible(false)}
        footer={
          <div>
            <Button 
              onClick={() => onHierarchyFormClose()}
            >
              {t('commons.buttons.close.title')}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (isHierarchyArtefactValid(hierarchy)) {
                  if (hierarchy.type === HIERARCHY_VALUE_BASED) 
                  {
                      onHierarchySave(hierarchy, appLanguage, isHierarchySelected, hclSelectedItems);
                  }
                  else 
                  {
                    Modal.error({
                      title: t('components.hierarchicalCodelistDetailItems.hierarchyForm.notSupported.title'),
                      content: t('components.hierarchicalCodelistDetailItems.hierarchyForm.notSupported.content')
                    });
                  }
                } else {
                  Modal.warning({
                    title: t('commons.alerts.invalidForm.title'),
                    content: t('commons.alerts.invalidForm.content')
                  });
                }
                
              }}
            >
              {t("commons.buttons.save.title")}
            </Button>
          </div>
        }
        withDataLanguageSelector
      >
          <HierarchyForm
            hierarchy={hierarchy}
            mode={hierarchyMode}
            onChange={setHierarchy}
          />
      </EnhancedModal>

    </Fragment>
  );
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(HierarchicalCodelistDetailItems);